// Modules
import React from 'react'
import Stories from 'react-insta-stories'

// Application
import AcessarExamesImg from 'assets/acessar-exames.svg'
import PessoaMenorIdadeImg from 'assets/pessoa-menor-idade.svg'

// Componentes
import { StoriesContainer } from './styles'
import { StoriesFinish } from './components/StoriesFinish'
import { StoriesInfos } from './components/StoriesInfos'
import { StoriesLogos } from './components/StoriesLogos'

const storiesInfoProps = {
    stepTwo: {
        infos: (
            <>
                Você pode acessá-los <strong>sem necessidade de cadastro. É só usar seu CPF, ou CIP e senha</strong>, que estão no
                protocolo entregue pelo laboratório.
            </>
        ),
        logo: AcessarExamesImg,
        title: 'Como acessar seus exames',
        step: 2,
    },
    stepThree: {
        infos: (
            <>
                Para acessar os resultados da pessoa menor de idade
                <strong> basta utilizar o CPF ou CIP e senha dela.</strong> <strong>incluí-la como um dependente</strong> na sua conta.
            </>
        ),
        logo: PessoaMenorIdadeImg,
        title: 'Pessoa menor de idade',
        step: 3,
    },
}

export const OnboardingModalStories = () => {
    const stories = [
        <StoriesLogos key={1} />,
        <StoriesInfos key={2} {...storiesInfoProps.stepTwo} />,
        <StoriesInfos key={3} {...storiesInfoProps.stepThree} />,
        <StoriesFinish key={4} />,
    ].map(story => ({ content: () => story }))

    return (
        <StoriesContainer>
            <Stories defaultInterval={15000} height="100vh" stories={stories} width="100%" />
        </StoriesContainer>
    )
}
